import { useRequestParams } from "contexts/RequestParamsProvider";
import { SortAscIcon, SortDescIcon, SortNoneIcon } from "icons";
import React, { useCallback } from "react";

export enum SORT_DIRECTION {
  ASC = "asc",
  DESC = "desc",
}

export const useSort = () => {
  const { activeSort, onChangeSort } = useRequestParams();

  const setCurrentSort = useCallback(
    (key: string) => {
      if (activeSort?.key === key) {
        switch (activeSort.direction) {
          case SORT_DIRECTION.ASC:
            onChangeSort(key, SORT_DIRECTION.DESC);
            break;
          case SORT_DIRECTION.DESC:
            onChangeSort();
            break;
          default:
            onChangeSort(key, SORT_DIRECTION.ASC);
        }
      } else {
        onChangeSort(key, SORT_DIRECTION.ASC);
      }
    },
    [activeSort, onChangeSort]
  );

  const getSortIcon = React.useCallback(
    (column: ColumnDefinition) => {
      const color = activeSort?.key === column.sortKey ? "black" : "grey.500";
      if (activeSort?.key === column.sortKey) {
        return activeSort?.direction === SORT_DIRECTION.ASC ? (
          <SortAscIcon color={color} />
        ) : (
          <SortDescIcon color={color} />
        );
      }
      return <SortNoneIcon color={color} />;
    },
    [activeSort]
  );
  return { activeSort, setCurrentSort, getSortIcon };
};

export default useSort;
